module.exports = __webpack_public_path__ + "static/media/intro_page_public.0b16f3b7.png";